import {reqWithToken} from './requestHelper';

export async function getForm(id){
    return (await reqWithToken(`api/gxbooking/forms/${id}`)).data;
}

export async function cancel(id){
    return (await reqWithToken('api/gxbooking/forms/cancel',{
        params: {id},
        method: 'patch'
    })).data;
}